// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import * as HeaderActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/header';
import * as FooterActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/footer';
import PageTracker from 'app-lib/helpers/page-tracker';
import Page from 'src/model/page';

const classPrefix = 'error-page';
export class NotFound extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        PageTracker.lastPage = Page.NOT_FOUND;
        const {t} = this.props;
        this.setHeader();
        this.props.initFooter({
            isActive: true,
            classes: 'generic-page-footer',
            left: <span>{t('channel.footer.powered')}</span>,
            right: [
                <span id="terms&conditions" key="terms&conditions">
                    <a href={`${config.company.termsOfService}`} target="_blank" rel="noopener">
                        {t('channel.footer.tnc')}
                    </a>
                </span>,
                <span key="privacy">
                    <a href={`${config.company.privacyPolicy}`} target="_blank" rel="noopener">
                        {t('channel.footer.privacy')}
                    </a>
                </span>,
                <span key="rights">
                    {t('channel.footer.copyright')} {t('channel.footer.company')}
                </span>
            ]
        });
    }

    componentWillUnmount() {
        this.props.initHeader();
        this.props.initFooter();
    }

    setHeader() {
        const self = this;
        self.props.initHeader({
            navbarBackgroundClasses: 'error-page-header-nav-bar',
            menuItemTextClasses: 'error-page-header-menu-item-text',
            showAlternateLogo: true
        });
    }

    render() {
        const {t} = this.props;
        return (
            <div className={`${classPrefix}-content-center`}>
                <img src={`${config.assets.url}/images/error/error_page_not_found.png`} alt="" />
                <div className="content-head">{t('notFound.notAvailable')}</div>
                <div className="content-description">
                    <div>{t('notFound.linkNA')}</div>
                    <div className="hide">{t('notFound.toContinue')} <a href={`${config.app.baseUrl}`}>{t('notFound.homepage')}</a></div>
                </div>
            </div>
        );
    }
}

NotFound.propTypes = {
    t: PropTypes.func.isRequired,
    initHeader: PropTypes.func.isRequired,
    initFooter: PropTypes.func.isRequired
};

export default connect(
    null,
    dispatch => bindActionCreators(Object.assign({}, HeaderActions, FooterActions), dispatch)
)(translate(['translation'])(NotFound));



// WEBPACK FOOTER //
// ./src/components/errors/notfound.js